/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ColumnTypeRating({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M6.547 2.217c.572-1.24 2.334-1.24 2.906 0l1.115 2.417a.4.4 0 0 0 .316.23l2.642.313c1.356.16 1.9 1.836.898 2.763L12.47 9.747a.4.4 0 0 0-.12.372l.518 2.61c.266 1.339-1.16 2.375-2.35 1.708l-2.323-1.3a.4.4 0 0 0-.39 0l-2.322 1.3c-1.192.667-2.617-.37-2.351-1.708l.518-2.61a.4.4 0 0 0-.12-.372L1.576 7.94c-1.003-.927-.458-2.602.898-2.763l2.642-.314a.4.4 0 0 0 .317-.23l1.114-2.416Zm1.816.503a.4.4 0 0 0-.726 0L6.522 5.136a1.6 1.6 0 0 1-1.264.92l-2.643.312a.4.4 0 0 0-.224.691l1.953 1.807a1.6 1.6 0 0 1 .483 1.487l-.518 2.61a.4.4 0 0 0 .587.427l2.322-1.3a1.6 1.6 0 0 1 1.563 0l2.322 1.3a.4.4 0 0 0 .588-.427l-.518-2.61a1.6 1.6 0 0 1 .483-1.487l1.953-1.807a.4.4 0 0 0-.224-.69l-2.643-.314a1.6 1.6 0 0 1-1.264-.919L8.363 2.72Z" clipRule="evenodd" /></svg>;
}
;